import React, { useState } from 'react';

const sizeClasses = {
  sm: 'size-8 text-xs',
  md: 'size-9 text-sm',
  lg: 'size-14 text-lg',
  xl: 'size-20 text-2xl',
};

/**
 * A person's photo, or their initials when there is no photo (or it fails to load).
 */
const Avatar = ({ name = '', src, size = 'md', className = '' }) => {
  const [hasImageFailed, setHasImageFailed] = useState(false);

  const initials = name
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((namePart) => namePart[0].toUpperCase())
    .join('');

  const classes = `${sizeClasses[size] || sizeClasses.md} shrink-0 rounded-full ${className}`;

  if (src && !hasImageFailed) {
    return (
      <img
        src={src}
        alt=""
        className={`${classes} object-cover ring-1 ring-ui-line`}
        onError={() => setHasImageFailed(true)}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={`${classes} flex items-center justify-center bg-brand-100 font-semibold text-brand-800 dark:bg-brand-500/20 dark:text-brand-200`}
    >
      {initials || '?'}
    </span>
  );
};

export default Avatar;
